import { Link } from 'react-router'
import { useTheme } from '../utils/higher-order-components/with-theme'
import { getEnvironmentData } from '../utils/hooks/get-environment-data.ts'
import DarkMode from './icons/dark-mode.tsx'
import LightMode from './icons/light-mode.tsx'
import QuestionFillBlack from './icons/question-fill-black.tsx'
import QuestionFill from './icons/question-fill.tsx'
import * as styles from './navigation-bar.css.ts'

export function NavigationBarStub() {
  const { theme, toggleTheme } = useTheme()
  const environmentData = getEnvironmentData()

  return (
    <nav className={styles.navbar}>
      <div className={styles.leftGroup}>
        <Link to={'/'}>
          <div className={styles.navBarBrand}>
            <img src={environmentData.logoIconHref} alt={environmentData.logoIconAlt} height={32} />
            {environmentData.name === 'ntt' ? '' : ' Pixee'}
          </div>
        </Link>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px' }}>
        <a href="https://docs.pixee.ai" target="_blank" style={{ width: '24px', height: '24px', lineHeight: '0' }}>
          {theme === 'dark' ? <QuestionFill /> : <QuestionFillBlack />}
        </a>

        <button onClick={toggleTheme} style={{ cursor: 'pointer' }}>
          {theme == 'light' ? <LightMode /> : <DarkMode />}
        </button>
      </div>
    </nav>
  )
}
